<template>
  <div class="book-slider">
    <vueper-slides
      autoplay
      :fixed-height="true"
      class="no-shadow"
      :visible-slides="4"
      slide-multiple
      :arrows-outside="false"
      :bullets="false"
      :infinite="true"
      :dragging-distance="100"
      :touchable="true"
      :disable-arrows-on-edges="true"
      :breakpoints="{ 400: { visibleSlides: 1 }, 800: { visibleSlides: 2 } }"
    >
      <vueper-slide v-for="(slide, i) in slides" :key="i" :image="slide.image">
        <template #content>
          <div></div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "SliderBook",
  data() {
    return {
      title: "SliderBook",
      slides: [
        {
          image: require("@/assets/images/slider_book/book_1.jpg"),
        },
        {
          image: require("@/assets/images/slider_book/book_2.jpg"),
        },
        {
          image: require("@/assets/images/slider_book/book_3.jpg"),
        },
        {
          image: require("@/assets/images/slider_book/book_4.jpg"),
        },
      ],
    };
  },
  components: { VueperSlides, VueperSlide },
};
</script>
<style lang="scss" scoped>
.book-slider
{
  .vueperslides {
    height: 22rem;
    margin-bottom: 0;
  }
}
</style>
